var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsRetailandServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.22217 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#e76728",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.695 20.3223c-1.1378 0-2.0759.9181-2.0759 2.0758 0 1.1377.9182 2.0758 2.0759 2.0758 1.1377 0 2.0758-.9182 2.0758-2.0758-.02-1.1377-.9381-2.0758-2.0758-2.0758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.3476 10.4215c-.0399 0-.0998-.02-.1596-.02h-12.5747l-.1996-1.33725c-.1197-.87823-.87821-1.53691-1.7764-1.53691h-1.61674c-.43912 0-.79839.35928-.79839.79839 0 .43912.35927.79839.79839.79839h1.61674c.0998 0 .17963.07984.19959.17964l1.23751 8.42304c.1597 1.0578 1.0778 1.8562 2.1557 1.8562h8.3032c1.0379 0 1.9361-.7385 2.1557-1.7564l1.2973-6.4869c.0799-.4192-.1996-.8384-.6387-.9182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6054 22.2983c-.0399-1.0978-.9581-1.976-2.0559-1.976-1.1576.0598-2.0359 1.0179-1.9959 2.1556.0399 1.0978.9381 1.976 2.0358 1.976h.04c1.1377-.0598 2.0359-1.0179 1.976-2.1556z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsRetailandServices);
export default __webpack_public_path__ + "static/media/AmenitiesIconsRetailandServices.854e20ffce3d3e9433bf835a02bc2947.svg";
export { ForwardRef as ReactComponent };